import React from 'react';
import PropTypes from 'prop-types';
import { Accordion, AccordionHeader, AccordionBody, Typography } from '@one-thd/sui-atomic-components';
import { track } from '../../../analytics/analytics';
import { FAQ_EXPEND } from '../../../constants/analytics';

export const Section = ({ section, index }) => {
  const { title, FAQs } = section;

  return (
    <div className={index !== 0 ? 'sui-mt-12' : ''}>
      <Typography variant="h4">{title}</Typography>
      <div className="sui-mt-6">
        {FAQs.map(({ question, answer, analyticsValue }, ind) => (
          <div className="sui-mb-6">
            <Accordion
              key={question}
              onChange={(__, isExpanded) => {
                if (isExpanded) track(FAQ_EXPEND, { value: analyticsValue });
              }}
            >
              <AccordionHeader aria-controls={`section${index}-accordion${ind}-content`} id={`section${index}-accordion${ind}-header`}>
                {question}
              </AccordionHeader>
              <AccordionBody style={{
                borderStyle: 'solid'
              }}
              >
                <div className="sui-font-regular sui-text-base sui-tracking-normal sui-normal-case
                sui-line-clamp-unset"
                >
                  {answer}
                </div>
              </AccordionBody>
            </Accordion>
          </div>
        ))}
      </div>
    </div>
  );
};

Section.propTypes = {
  index: PropTypes.number.isRequired,
  section: PropTypes.shape({
    title: PropTypes.string,
    FAQs: PropTypes.arrayOf(PropTypes.shape({ question: PropTypes.string,
      answer: PropTypes.node }))

  }).isRequired
};

export default Section;
